import withDraft from '@/utils/draftHelper';
import findResult, { assignProps, removeItemByCode } from '@/utils/resultsHelper';
import { closeDatasetSettingsState, findAllDatasetPermissions } from './state';
import actions from '../../constants';

const updateCurrentDatasetPermissions = withDraft((draft, { code, permissions }) => {
  findAllDatasetPermissions(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.permissions, category, code);
    if (item) {
      assignProps(item, { ...permissions });
    }
  });
});

const destroyDataset = withDraft((draft, { items }) => {
  findAllDatasetPermissions(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.permissions, category, code);
      if (item) {
        draft.permissions[category].results = removeItemByCode(draft.permissions[category].results, item);
      }
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
  [actions.FINISH_DATASET_WIZARD]: closeDatasetSettingsState,
  [actions.UPDATE_CURRENT_DATASET_PERMISSIONS]: updateCurrentDatasetPermissions,
};
